<div class="popup-container" [ngClass]="color === 'RED' ? 'bg-red' : 'bg-black'">
    <div class="popup">
        <div class="title">CONFIRMED</div>
        <div class="text">GOOD LUCK!</div>
        <button class="close-btn" (click)="cancel()">✕</button>
    </div>
</div>
